import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import * as errorAction from '../../core/actions/clear-error.action';
import { ContainerComponent } from '../../modules/shared/components/container-component/unsubscribe.component';
import { selectAuthenticationError } from '../../modules/url-params/url-params.selector';
import { UrlParamsState } from '../../modules/url-params/url-params.state';

@Component({
    selector: 'ssf-unauthorized-page',
    template: require('./unauthorized.component.html'),
    styles: [
            `
            :host {
                text-align: center;
            }
        `,
    ],
})

/**
 * Unauthorized access without AT.
 */
export class UnauthorizedComponent extends ContainerComponent {
    public i18n = 'APP.UNAUTHORIZED.';
    public errorDescription: string;

    constructor(private store: Store<UrlParamsState>) {
        super();
        this.store.dispatch(new errorAction.ClearErrorAction());
        this.store.select(selectAuthenticationError)
            .takeUntil(this.ngUnsubscribe)
            .subscribe((description: string) => {
                this.errorDescription = description;
            });
    };
}
;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/unauthorized/unauthorized.component.ts